import {
  DialogOptions,
  type DialogOptionsOption,
  type DialogProps,
} from "@verde/compose-ui";
import { useFetchInvestmentFunds, useUpdateOneClient } from "@verde/entities";
import React, { useCallback } from "react";

type FundsSelectorProps = Pick<DialogProps, "onClose"> & {
  client_id?: number;
  defaultValue?: Array<number>;
  onSubmit?: () => void;
};

function FundsSelector({
  client_id,
  defaultValue,
  onClose,
  onSubmit,
}: FundsSelectorProps) {
  const { data, isLoading } = useFetchInvestmentFunds();

  const update = useUpdateOneClient(client_id);

  const handleSubmit = useCallback(
    async (values: DialogOptionsOption[]) => {
      await update.mutateAsync({
        investment_fund_ids: values.map((item) => item.value),
      });

      onSubmit?.();
    },
    [update, onSubmit],
  );

  return (
    <DialogOptions
      open
      onClose={onClose}
      kind="multiple"
      title="Selecionar fundos"
      description="Selecione os fundos onde o cliente será associado"
      loading={isLoading}
      value={defaultValue}
      submitting={update.isLoading}
      options={data?.data.map(({ id, name, client_ids }) => {
        return {
          value: id,
          label: name,
          description: `${client_ids.length} clientes`,
        };
      })}
      onSubmit={handleSubmit}
    />
  );
}

export default React.memo(FundsSelector);
